import { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  type ThemeOptions,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';

import { palette } from './palette';
import { typography } from './typography';
import { shadows } from './shadows';
import { customShadows } from './customShadows';
import componentsOverride from './overrides';
import { GlobalStyles } from './globalStyles';

// ----------------------------------------------------------------------

interface Props {
  children: React.ReactNode;
}

export default function ThemeProvider({ children }: Props) {
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: palette('light'),
      typography,
      shape: { borderRadius: 8 },
      direction: 'ltr',
      shadows: shadows('light'),
      customShadows: customShadows('light'),
    }),
    []
  );

  const theme = createTheme(themeOptions);

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
